module.exports = __webpack_public_path__ + "img/dentalfit_1_b.2d1d041f.jpg";